module.exports = __webpack_public_path__ + "static/media/SourceSansPro-It.04423b65.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SourceSansPro-It.ttf
// module id = 338
// module chunks = 3